import { AuthFetchError } from '@e3dc-react/shell/Types'
import { ApiResult } from 'src/Libs/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { AuthFetchWithResponse } from 'src/Types/api'

interface CreateQntmStorageDeviceLinkPayload {
  deviceName: string
  type: 'qntm'
  serial: string
}

export const createQntmStorageDeviceLink = async (
  authFetch: AuthFetchWithResponse,
  installationId: number,
  emcDeviceLinkId: number,
  payload: CreateQntmStorageDeviceLinkPayload
): Promise<ApiResult<void, AuthFetchError | Error>> => {
  try {
    const response = await authFetch({
      path: `installations/${installationId}/device-links/${emcDeviceLinkId}/sub/qntm-storage`,
      method: 'POST',
      payload,
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })

    if (response.status === StatusCodes.OK || response.status === StatusCodes.CREATED || response.status === StatusCodes.NO_CONTENT) {
      return new ApiResult<void, AuthFetchError | Error>()
    }

    return new ApiResult<void, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<void>(error)
  }
}
